<template>
	<div
		:class="['panel', 'youtube',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div class="container">
			<!-- <div class="panel_header mb-5">
				<div class="row align-items-end">
					<div class="col-12 col-md-8 col-lg-9">
						<div class="title">Cейчас в прямом эфире:</div>
						<h2>Влияние коронавируса на ТЭК</h2>
					</div>
					<div class="col-12 col-md-4 col-lg-3 text-center text-md-right">
						<button class="btn btn-lg btn-danger mb-2 mt-3">Смотреть online</button>
					</div>
				</div>
				<hr>
			</div> -->
			<div
				v-if="isHeaderVisible"
				:class="[
					'panel_header',
					isBrand? 'sk' : '',
				]"
			>
				<div class="row align-items-end">
					<div class="col-12">
						<h2 v-if="block.block_title === null">
							Посмотрите, как это было
						</h2>
						<h2 v-else>
							{{ block.block_title }}
						</h2>
					</div>
				</div>
			</div>
			<div class="youtube_block">
				<CoolLightBox
					:items="videosSource"
					:full-screen="true"
					:index="index"
					@close="index = null"
				/>
				<ul class="youtube_list row">
					<li
						v-for="(item, imageIndex) in visibleVideos"
						:key="imageIndex"
						class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3"
					>
						<div class="youtube-item" @click="index = imageIndex">
							<div class="youtube-image icon-video">
								<b-img-lazy
									:src="item.video.snippet.thumbnails.high.url"
									:alt="item.video.snippet.title"
									:offset="0"
								/>
							</div>
							<div class="youtube-title">
								{{ index }}{{ item.video.snippet.title }}
							</div>
							<div v-if="$i18n.locale ==='en'" class="youtube-viewCount">
								{{ item.video.statistics.viewCount }} views
							</div>
							<div v-else class="youtube-viewCount">
								просмотров: {{ item.video.statistics.viewCount }}
							</div>
						</div>
					</li>
				</ul>
			</div>
			<div v-if="expandable" class="panel_footer">
				<button
					v-b-tooltip.hover.top="videoLimit === defaultVideoLimit ? $t('show') : $t('hide') "
					class="btn btn-resize icon-chevron"
					:aria-label="$t('show')"
					:class="videoLimit === defaultVideoLimit ? 'collapsed' : null"
					@click="toggle"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox';
import panel from '~/mixins/panel';

import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

const DEFAULT_VIDEO_LIMIT = 4;

export default {
	name: 'PanelPlaylistYoutube',
	components: {
		CoolLightBox,
	},
	mixins: [panel],
	data() {
		return {
			videos: [],
			index: null,
			videoLimit: DEFAULT_VIDEO_LIMIT,
		};
	},
	computed: {
		expandable() {
			const MAX_VIDEOS_IN_COLUMN = 4;

			const { expandable } = this.block.content;
			if (expandable !== undefined && expandable !== null) {
				return expandable;
			}

			return (this.videos && this.videos.length > MAX_VIDEOS_IN_COLUMN);
		},
		defaultVideoLimit() {
			return this.block.content.collapsed_count || DEFAULT_VIDEO_LIMIT;
		},
		visibleVideos() {
			return this.videos.slice(0, this.videoLimit);
		},
		videosSource() {
			return Array.isArray(this.videos)
				? this.videos.map((item) => ({
					title: item.video.snippet.title,
					// description: item.video.snippet.localized.description,
					thumb: item.video.snippet.thumbnails.high.url,
					src: `https://www.youtube.com/watch?v=${item.video.id}`,
				}))
				: [];
		},
	},
	watch: {
		defaultVideoLimit: {
			handler(defaultVideoLimit, old) {
				if (defaultVideoLimit !== old) {
					this.videoLimit = defaultVideoLimit;
				}
			},
			immediate: true,
		},
	},
	mounted() {
		if (this.block.content.playlist_id) {
			this.$api.axios.$get(`api/playlist/${this.block.content.playlist_id}`, {
				params: {
					order: this.block.content.order,
				},
			}).then((data) => {
				this.videos = data.items;
			});
		} else {
			console.error('Playlist id empty');
		}
	},
	methods: {
		toggle() {
			if (this.videoLimit === this.defaultVideoLimit) {
				this.videoLimit = 100;
			} else {
				this.videoLimit = this.defaultVideoLimit;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/panel-youtube";
</style>
